import clsx from 'clsx'
import {FirstAdBonusPromoCard} from './FirstAdBonusPromoCard'
import {PromoteYourAdsPromoCard} from './PromoteYourAdsPromoCard'
import {RepayAdvanceAfterSellPromoCard} from './RepayAdvanceAfterSellPromoCard'

interface Props {
    baseClassName?: string
    className?: string
    cardClassName?: string
    firstAdBonus?: boolean
    promoteYourAd?: boolean
    repayAdvanceAfterSell?: boolean
    utmSource?: string
    size?: 'sm' | 'md' | 'lg'
}

// Блок с карточками промо-акций
export function PromoCards(props: Props) {
    const {
        baseClassName = 'full-width d-grid grid-columns-1 col-gap-4 row-gap-4',
        className,
        cardClassName,
        firstAdBonus = true,
        promoteYourAd = true,
        repayAdvanceAfterSell = false,
        utmSource,
        size = 'md',
    } = props

    return (
        <div className={clsx('promo-cards-block', baseClassName, className)}>
            {firstAdBonus && (
                <FirstAdBonusPromoCard
                    className={cardClassName}
                    utmSource={utmSource}
                    size={size}
                />
            )}
            {promoteYourAd && (
                <PromoteYourAdsPromoCard
                    className={cardClassName}
                    utmSource={utmSource}
                    size={size}
                />
            )}
            {repayAdvanceAfterSell && (
                <RepayAdvanceAfterSellPromoCard
                    className={cardClassName}
                    utmSource={utmSource}
                    size={size}
                />
            )}
        </div>
    )
}
